import type { EventCategory } from "@/types"
import { getMetas } from "../mixins/modularFirebaseOperations"
import firebase from "firebase"
import { Ref, ref } from "vue"
import eventCategoriesVue from "@/components/calendar/eventCategories.vue"
import { getDataFromGS } from "@/composables/googleSheetOperations"
import axios from "axios"
import type { ByEvent } from "@/types/events"
export const getAllEvents = async (eventsArray: any[], isLoading: Ref<boolean>) => {
    isLoading.value = true
    const eventsRef = firebase.firestore().collection("events")

    eventsRef.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            eventsArray.push(
                {
                    id: doc.id,
                    title: doc.data().title,
                    time: doc.data().time,
                    description: doc.data().description,
                    // with: doc.data().with,
                    colorScheme: doc.data().category,
                    isEditable: doc.data().isEditable,
                }
            )

            isLoading.value = false

        });
    })
}


export const mapEventCatsToColorSchemes = async function (eventCats: Ref<EventCategory[]>, calendarConfig: any, isLoadingEventCats: Ref<boolean>) {
    await getMetas("metas/calendar/eventCats", eventCats.value, isLoadingEventCats)

        // Directly map over the eventCats array
        const colorSchemes = Object.fromEntries(
            eventCats.value.map(cat => [cat.name, {
                "backgroundColor": cat.color,
                "color": "#fff"
            }])
        );
    
        calendarConfig.style.colorSchemes = colorSchemes;
}

export const useGetEmployeeBirthdays = () => {
    const birthdays = ref([])
    const isLoadingBirthdays = ref(false)

    const convertBirthDateToCalendarTime = (birthDate: string) => {
        const birthDateArray = birthDate.split(".")

        const birthDateDay = birthDateArray[0]
        const birthDateMonth = birthDateArray[1]
        const year = new Date().getFullYear()

        const birthDateCalendarTime = (`${year}-${birthDateMonth}-${birthDateDay}`)
       

        return birthDateCalendarTime
    }

    const getBirthdays = async () => {
        isLoadingBirthdays.value = true
        const birthdaysRef = firebase.firestore().collection("team")
        birthdaysRef.get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                const data = doc.data()
                // Only process team members who have a birthday field
                if (data.birthday) {
                    birthdays.value.push(
                        {
                            id: doc.id,
                            title: data.name.first + " " + data.name.last + " Doğum günü",
                            time: {
                                start: convertBirthDateToCalendarTime(data.birthday),
                                end: convertBirthDateToCalendarTime(data.birthday),
                            },                        
                            isEditable: false,
                            colorScheme: "Doğum günleri",
                        }
                    )
                }
            });
        })
        isLoadingBirthdays.value = false
    }



    getBirthdays()

    return { birthdays, isLoadingBirthdays }


}

const convertGoogleSheetDateToCalendarDate = (date: string) => {
    if(date.includes("/")) {
        const dateArray = date.split("/")
        return `${dateArray[2]}-${dateArray[0]}-${dateArray[1]}`
    }
    if(date.includes(".")) {
        const dateArray = date.split(".")
        return `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`
    }
}

const parseDBSData = (data: any[]) => {

    const DBSEventData: ByEvent = {
        id: "",
        title: "",
        time: {
            start: "",
            end: ""
        },
        description: "",
        colorScheme: "Geri Ödeme Tarihleri",
        isEditable: false,
    }
    // Get DBS information
    const DBSBankName = data[0]
    const firm = data[1]
    const DBSDate = data[2] // If this is not a date, disregard the row
    if(!DBSDate || !DBSDate.includes("/")) {
        return
    }
    const DBSAmount = data[3]
    const DBSCurrency = data[4]

    // Populate DBSEventData
    DBSEventData.id = `id-${DBSBankName.toLowerCase()}-${firm.toLowerCase()}-${DBSDate}`
    DBSEventData.title = `DBS Ödeme: ${firm}`
    DBSEventData.time.start = convertGoogleSheetDateToCalendarDate(DBSDate)
    DBSEventData.time.end = convertGoogleSheetDateToCalendarDate(DBSDate)
    DBSEventData.description = `DBS Ödeme: ${firm} için ${DBSAmount} ${DBSCurrency} tutarında ödeme yapılacak. Banka: ${DBSBankName ? DBSBankName : "Bilinmiyor"}`

    return DBSEventData
}

const parseKGFData = (data: any[]) => {
    console.log(data)
    const KGFEventData: ByEvent = {
        id: "",
        title: "",
        time: {
            start: "",
            end: ""
        },
        description: "",
        colorScheme: "Geri Ödeme Tarihleri",
        isEditable: false,
    }

    const KGFDate = data[5]
    console.log(KGFDate)
    if(!KGFDate || !KGFDate.includes(".")) {
        return null
    }
    const KGFAmount = data[6]
    const KGFCurrency = data[7]
    const KGFBankName = data[8]
    // Populate KGFEventData
    KGFEventData.id = `id-kgf-${KGFDate}-${KGFBankName}-${KGFAmount}`
    KGFEventData.title = `KGF Ödeme: ${KGFBankName}`
    KGFEventData.time.start = convertGoogleSheetDateToCalendarDate(KGFDate)
    KGFEventData.time.end = convertGoogleSheetDateToCalendarDate(KGFDate)
    KGFEventData.description = `KGF Ödeme: ${KGFBankName} - ${KGFAmount} ${KGFCurrency} tutarında ödeme yapılacak.`
    return KGFEventData
}

export const getRepaymentDates = () => {

    const url = "https://dansuk-dashboard-api.herokuapp.com/fetch-sheet-data"

    const repaymentDates = ref([])
    const isLoadingRepaymentDates = ref(false)

    const fetchRepaymentDates = async () => {
        const response = await axios.post(url, {
            sheetId: "12c_mv0qFkcOp1Hke90cLnCxTGbdDuJPd_fWiEzEPxwo",
            sheetName: "2026",
            sheetRange: "F17:N289"
        })


        const data = response.data.data 

        data.forEach((row: any) => {
            const dbsData = parseDBSData(row)
            if(dbsData) {
                repaymentDates.value.push(dbsData)
            }
            const kgfData = parseKGFData(row)
            if(kgfData) {
                repaymentDates.value.push(kgfData)
            }
        })

    }

    fetchRepaymentDates()

    return { repaymentDates, isLoadingRepaymentDates }
}

